import Joyride, { STATUS, Step } from 'react-joyride'
import { useState, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { IConfigSeller } from '@/models/configSeller'

export const useJoyRide = () => {
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const [runTour, setRunTour] = useState(false)
  const [steps, setSteps] = useState<Step[]>([])
  /* se expone el cierre del tour (saltado o finalizado) con los targets que tenía en ese momento,
     así cada módulo puede reaccionar solo cuando terminan SUS pasos, sin engancharse a los de otro */
  const [lastFinishedTour, setLastFinishedTour] = useState<{ status: string, targets: string[] } | null>(null)
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isHuaweiMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const canRunTour = configSeller.config.permisos.ENABLE_TOUR === 1

  /* react-joyride avanza su índice interno cuando el target del paso no está en el DOM
     (por ejemplo, un botón que desaparece tras usarlo). Ese índice no vuelve solo: queda
     apuntando fuera del arreglo y los pasos siguientes ya no se muestran hasta recargar.
     Remontando el componente en cada cambio de pasos el tour siempre arranca en el primero. */
  const stepsKey = steps.map((step) => String(step.target)).join('|')

  const JoyRideComponent: ReactNode = (
    <Joyride
      key={stepsKey}
      steps={steps}
      run={isSamsungMexico || isHuaweiMexico || isMacstoreMexico || canRunTour ? runTour : false}
      continuous
      showSkipButton
      showProgress={false}
      locale={{
        last: 'Entendido',
        skip: 'Saltar',
        next: 'Siguiente',
        back: 'Atrás'
      }}
      styles={{
        options: {
          zIndex: 9999,
          primaryColor: '#6366f1',
          textColor: '#222',
          arrowColor: '#fff',
          backgroundColor: '#fff',
          overlayColor: 'rgba(0,0,0,0.4)'
        },
        buttonNext: {
          backgroundColor: '#6366f1',
          color: '#fff',
          border: 'none'
        },
        buttonBack: {
          color: '#6366f1'
        },
        buttonSkip: {
          color: '#6366f1'
        }
      }}
      callback={(data) => {
        if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
          setRunTour(false)
          setLastFinishedTour({ status: data.status, targets: steps.map((step) => String(step.target)) })
        }
      }}
    />
  )

  return { JoyRideComponent, runTour, setRunTour, setSteps, lastFinishedTour }
}
